import { ICartItem, ICustomLineItem } from '../../../../container/cart/ICart';
import { safeGet } from '../../../../utils/objectUtils';
import {
  calculateTotalSavings,
  getFinalPrice,
  getOriginalPrice,
} from '../../../../utils/priceUtils';
import { ILineItem } from '../cartInterface';
import { Attributes, ProductTypes } from './../constants';
import { formatPrice } from './../reshapeCartData';
import { ContactLensAttributes } from './constants';
import { reshapeAttributesData } from './reshapeChildrenData';

export const reshapeContactLensData = (item: ILineItem, customLineItems: ICustomLineItem[]) => {
  const contactLens = {} as ICartItem;
  contactLens.id = item.id;
  contactLens.qty = item.quantity || 0;
  contactLens.sku = safeGet(item, 'variant.sku', '');
  contactLens.type = ProductTypes.CONTACT_LENS;
  contactLens.eye = safeGet(item, 'custom.fields.eyeIdentifier', '');
  contactLens.isPriceValid = item.isPriceValid;
  let prescriptions = safeGet(item, 'custom.fields.prescriptionId', '');
  contactLens.isPrescriptionActive = prescriptions?.status === 'active';
  contactLens.prescriptionId = prescriptions;
  const variantAttributes = safeGet(item, 'variant.attributes', []);
  const iswebEnabled = safeGet(item, 'variant.attributes', []).find((attr: any) => attr.name == Attributes.WEB_ENABLED)?.value || '';
  contactLens.iswebEnabled = iswebEnabled;
  if (variantAttributes.length) {
    contactLens.isAvailable =
      variantAttributes.find((attr: any) => attr.name === Attributes.IS_AVAILABLE)?.value || '';
    const title = variantAttributes.find(
      (attr: any) => attr?.name === ContactLensAttributes.NAME_FRIENDLY,
    );
    if (title?.value) {
      contactLens.title = title?.value;
    }
  }
  contactLens.price = formatPrice(safeGet(item, 'price.value.centAmount', 0) / 100);
  if (safeGet(item, 'variant.assets.0.sources.0.uri', '')) {
    contactLens.image = {
      src: item.variant.assets[0].sources[0]?.uri,
      alt: contactLens.title,
    };
  }
  contactLens.savings = formatPrice(calculateTotalSavings(item, customLineItems) ?? 0);
  contactLens.orgPrice = getOriginalPrice(contactLens, item);
  contactLens.price = getFinalPrice(item, customLineItems);
  contactLens.dimensions = [reshapeAttributesData(item)];
  contactLens.packSize = item.variant?.attributes?.find(item => item.name === 'PACK_SIZE')?.value;
  contactLens.colour = item.variant?.attributes?.find(item => item.name === 'COLOR')?.value;
  // TODO: We have to make a check for this which need backend change to return rx expiration date
  contactLens.isRXValid = true;

  return contactLens;
};
